module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticClass: "history__status",
    class: _vm.statusClass
  }, [_vm._v("\n    " + _vm._s(_vm.status)), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "__substatus text-center"
  }, [_vm._v(_vm._s(_vm.substatus))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d287a32", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d287a32","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderStatus.vue
// module id = 745
// module chunks = 1